import { Services } from "@/legacy/services/services";

export const servicesPlugin = {
  install(vue: any, services: Services) {
    vue.prototype.$services = services;
  },
};
